import FormControl from "@material-ui/core/FormControl"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import React, { useContext } from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useCreateWeChat } from "./hooks"
import { useWeChatModalStyle } from "./style"
import ChargePerson from "../ChargePerson"
import { AppContext } from "Views/Home/context"
import { Board } from "Types/board"
import Typography from "@material-ui/core/Typography"

const WeChatUpdate = () => {
    const classes = useWeChatModalStyle()
    const {
        callback, cancelCallback, dialogData, isPass, isThreeDay,
        disabled, dateStr, text, handleChange,
        external, handleChangeAuthor, handleChangeArticleType,
        staticArticleType, editCallback,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
    } = useCreateWeChat()
    const author = (dialogData.board as Board).author
    const creator = (dialogData.board as Board).creator_info
    const { roleMap, user } = useContext(AppContext)
    const { isTrueEditor, isOpEditor, isBusiness } = roleMap
    const { role } = creator
    const { role_name } = role
    const creatorIsUser = role_name === "user"
    const creatorIsSideEditor = role_name === "side_editor"
    const isMine = dialogData.board && dialogData.board.creator_id === user.uid
    // console.log(isPass && isBusiness)
    return (
        <BoardConfirmModal
            title="修改标题"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            editCallback={editCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="内容"
                    value={text}
                    disabled={(isPass || isThreeDay) && isBusiness}
                    onChange={handleChange}
                />
                <Grid item>
                    <FormControl disabled={(isPass || isThreeDay) && isBusiness} className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            rowData={{
                                article_type_id: external.articleTypeId,
                            }}
                            staticValueList={staticArticleType}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            // 2026-03 文章类型=“说明” 仅编辑部主编可预约
                            whereQuery={`where: {hidden: {_eq: false}${!isTrueEditor ? ', name: {_neq: "说明"}' : ''}}`}
                        />
                    </FormControl>
                </Grid>
                {/*除编辑部主编和编辑部运营外的角色在预约微信点位时，不再需要填写“负责人”*/}
                {/*编辑部主编和编辑部运营对于(点位运营/编辑部编辑)预约的点位进行修改时，不再显示负责人*/}
                {(isTrueEditor || isOpEditor) && !creatorIsUser && !creatorIsSideEditor && (
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel>负责人</InputLabel>
                            <ChargePerson
                                chargePerson={author ? author.name : ""}
                                handleChangeAuthor={handleChangeAuthor}
                            />
                        </FormControl>
                    </Grid>
                )}
                <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid>
            </Grid>

            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine ? (
                    <>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
            {
                isBusiness && isThreeDay ? (
                    <>
                        <Grid container justify="flex-start" alignItems="center" className={classes.input}>
                                <Typography color="initial">
                                    注意：3天内的预约不能修改/删除哦~
                                </Typography>
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default WeChatUpdate
